import React, { useState } from 'react';

const AddCustomer = ({ onClose }) => {
  const [name, setName] = useState('');
  const [location, setLocation] = useState('Sarai');
  const [phone, setPhone] = useState('');
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(null);

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    // Reset previous messages
    setError(null);
    setSuccess(null);

    try {
      const response = await fetch('https://app.mirzawaleed.com/addcustomer.php', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ name, location, phone }),
      });
      const result = await response.json();
      if (result.success) {
        setSuccess('Customer added successfully.');
        if (onClose) onClose(); // Close the modal or sheet
      } else {
        setError(result.message);
      }
    } catch (err) {
      console.error('Error adding customer:', err);
      setError('An error occurred while adding the customer.');
    }
  };

  return (
    <div style={overlayStyle}>
      <div style={modalStyle}>
        <h2>Add Customer</h2>
        <form onSubmit={handleSubmit}>
          <div style={formGroupStyle}>
            <label style={labelStyle}>Name:</label>
            <input
              type="text"
              value={name}
              onChange={(e) => setName(e.target.value)}
              required
              style={inputStyle}
            />
          </div>
          <div style={formGroupStyle}>
            <label style={labelStyle}>Location:</label>
            <select
              value={location}
              onChange={(e) => setLocation(e.target.value)}
              style={inputStyle}
            >
              <option value="Sarai">Sarai Alamgir</option>
              <option value="Jhelum">Jhelum</option>
              <option value="Kharian">Kharian</option>
              <option value="Sarai2">Sarai 2</option>
            </select>
          </div>
          <div style={formGroupStyle}>
            <label style={labelStyle}>Phone:</label>
            <input
              type="text"
              value={phone}
              onChange={(e) => setPhone(e.target.value)}
              required
              style={inputStyle}
            />
          </div>
          {error && <p style={errorStyle}>{error}</p>}
          {success && <p style={successStyle}>{success}</p>}
          <div style={buttonContainerStyle}>
            <button type="submit" style={submitButtonStyle}>Add Customer</button>
            <button type="button" onClick={onClose} style={cancelButtonStyle}>Cancel</button>
          </div>
        </form>
      </div>
    </div>
  );
};

// Styles
const overlayStyle = {
  width: '100%',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
};

const modalStyle = {
  backgroundColor: '#fff',
  padding: '20px',
  borderRadius: '8px',
  boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
  width: '100%',
};

const formGroupStyle = {
  marginBottom: '15px',
};

const labelStyle = {
  display: 'block',
  marginBottom: '5px',
  fontWeight: 'bold',
};

const inputStyle = {
  width: '100%',
  padding: '8px',
  border: '1px solid #ccc',
  borderRadius: '4px',
};

const buttonContainerStyle = {
  display: 'flex',
  justifyContent: 'space-between',
};

const submitButtonStyle = {
  backgroundColor: '#4CAF50',
  color: '#fff',
  border: 'none',
  padding: '10px 20px',
  borderRadius: '4px',
  cursor: 'pointer',
};

const cancelButtonStyle = {
  backgroundColor: '#f44336',
  color: '#fff',
  border: 'none',
  padding: '10px 20px',
  borderRadius: '4px',
  cursor: 'pointer',
};

const errorStyle = {
  color: '#f44336',
  marginBottom: '10px',
};

const successStyle = {
  color: '#4CAF50',
  marginBottom: '10px',
};

export default AddCustomer;
